import { useQuery } from '@tanstack/react-query';

import { getUserTierApi } from '@flipster/apis/v1/user';
import { isTradingFeeFeatureEnabled } from '@flipster/utils/feature-flag';
import Num from '@flipster/utils/num';

import { useAuth } from '../auth/state';

export const useUserTier = () => {
  const { isCookieLoggedIn } = useAuth();

  const {
    data: userTier,
    refetch: refetchTier,
    isPending: isTierLoading,
  } = useQuery({
    queryKey: ['getUserTierApi'],
    queryFn: getUserTierApi,
    select: (res) => res.data,
    enabled: isCookieLoggedIn,
  });

  const isVipTrialForNonVips = userTier?.status === 'TIER_STATUS_VIP_TRIAL' && userTier?.vipTrialType === 'LIMITED'; // vip 스쿼드에서 운영중인 특수한 status (VIP Earn Pool 혜택이 제한되는 trial 유저)
  const isVipGrace = isTradingFeeFeatureEnabled
    ? userTier?.status === 'TIER_STATUS_VIP_GRACE'
    : userTier?.status === 'TIER_STATUS_VIP_GRACE' || userTier?.status === 'TIER_STATUS_VIP_TRIAL';
  const isVip = isTradingFeeFeatureEnabled ? (userTier?.vipTier || 0) > 0 : userTier?.status !== 'TIER_STATUS_BASIC';
  const isMaxTier = userTier && userTier.vipTier === userTier.maxVipTier;
  const isVipPending =
    userTier &&
    !isMaxTier &&
    ((userTier.thresholdVolume && Num(userTier.lastVolume).gte(userTier.thresholdVolume)) ||
      (userTier?.thresholdUsdtBalance && Num(userTier?.lastUsdtBalance24h ?? '0').gte(userTier.thresholdUsdtBalance)));
  const isVipBoosting = Boolean(userTier?.boostValidUntil);

  return {
    userTier,
    isVipTrialForNonVips,
    isVipGrace,
    isVip,
    isVipBoosting,
    isTierLoading,
    isVipPending,
    isMaxTier,
    refetchTier,
  };
};
